export default "__VITE_ASSET__NMdwfClP__"